module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "intro__content"
  }, [_c('div', {
    staticClass: "intro__text"
  }, [_c('a', {
    attrs: {
      "href": "http://jepser.com?ref=spotify-youtube"
    }
  }, [_c('svg', {
    attrs: {
      "width": "62px",
      "height": "72px",
      "viewBox": "0 0 62 72",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "jepser-logo-container",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Menu",
      "transform": "translate(-52.000000, -22.000000)",
      "stroke": "#000000"
    }
  }, [_c('g', {
    attrs: {
      "id": "jepser-logo",
      "transform": "translate(53.000000, 23.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "",
      "id": "Path-2",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Path-3",
      "stroke-width": "1",
      "points": "35.644009 0.426295571 6.76012285 16.7859514 0.196913639 31.7522465 15.0248336 50.8396861 36.3788066 68.6695776 59.2651559 35.5204062 58.9371556 11.5827903"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "id": "Path-4",
      "stroke-width": "1",
      "points": "6.92988863 17.4169676 29.7912536 31.9284185 16.3733505 51.3131084"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "id": "Path-5",
      "stroke-width": "1",
      "points": "36.7497288 68.268546 27.7130641 53.4290947 16.4041005 51.4418741"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "id": "Path-7",
      "stroke-width": "1",
      "points": "58.7597023 12.3182285 50.8229918 26.6964293 36.6760568 67.7880768"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.6809054,36.3282351 L42.1563726,52.4984291",
      "id": "Path-8",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36,1 L50.6325055,26.6986155",
      "id": "Path-9",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.5698452,26.9083714 L27.7463381,53.1766809",
      "id": "Path-10",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "id": "Path-11",
      "stroke-width": "1",
      "points": "35.8191765 0.874267509 29.9683231 32.0354962 27.6935594 53.156559"
    }
  })])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "intro__title"
  }, [_vm._v("Convert your Spotify to Youtube playlists")]), _vm._v(" "), _c('a', {
    staticClass: "button button--green intro__login",
    on: {
      "click": _vm.loginSpotify
    }
  }, [_vm._v("Start creating")]), _vm._v(" "), _c('p', {
    staticClass: "intro__description"
  }, [_vm._v("I created it for the fun of having a tool for parties, convert yours. Is free ;)")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro__presented"
  }, [_vm._v("Created by "), _c('br'), _vm._v("Jepser Bernardino")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2352242c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 52
// module chunks = 0